"use strict";

exports.__esModule = true;
exports["default"] = exports.BackgroundContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _animations = require("@qc-modules/animations");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BackgroundContainer = (0, _styledComponents["default"])(_components.Background).withConfig({
  displayName: "mobile-header__BackgroundContainer",
  componentId: "sc-1qps31s-0"
})(["position:absolute;top:0;z-index:1;box-shadow:0 4px 32px 0 ", ";"], function (props) {
  return (0, _styles.themeTransparentize)(0.76, "background-dark", props);
});
exports.BackgroundContainer = BackgroundContainer;
var propTypes = {
  backgroundColor: _propTypes.string,
  cancelOnClick: _propTypes.func.isRequired,
  className: _propTypes.string,
  htmlId: _propTypes.string,
  resetOnClick: _propTypes.func.isRequired,
  resultsCount: _propTypes.number,
  showReset: _propTypes.bool,
  textAlign: _propTypes.string,
  title: _propTypes.node
};
var defaultProps = {
  backgroundColor: "background-dark",
  className: "",
  htmlId: "",
  resultsCount: 0,
  showReset: false,
  textAlign: "center",
  title: ""
};

var MobileHeader = function MobileHeader(_ref) {
  var backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      resultsCount = _ref.resultsCount,
      htmlId = _ref.htmlId,
      textAlign = _ref.textAlign,
      title = _ref.title,
      showReset = _ref.showReset,
      resetOnClick = _ref.resetOnClick,
      cancelOnClick = _ref.cancelOnClick;
  return /*#__PURE__*/_react["default"].createElement(BackgroundContainer, {
    backgroundColor: backgroundColor,
    className: className,
    display: ["flex", "flex", "none"],
    forwardedAs: "section",
    height: "75px",
    id: htmlId,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    justifyContent: "center",
    px: [3, 5, 5, 130],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flex: "1 0 25%"
  }, /*#__PURE__*/_react["default"].createElement(_animations.Fade, {
    alwaysShowInDom: false,
    enterDuration: 0.25,
    exitDuration: 0.2,
    show: showReset
  }, /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    fontSize: 2,
    letterSpacing: "0.5px",
    mb: 0,
    onClick: resetOnClick,
    version: "link"
  }, "Reset"))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    flex: "1 0 50%",
    flexDirection: ["column", "row"],
    flexWrap: "wrap",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_components.Heading, {
    color: "black",
    display: "flex",
    fontSize: 3,
    fontWeight: 2,
    letterSpacing: "0.5px",
    lineHeight: [2, 2, 1, 1, 1, 1],
    mb: 0,
    textAlign: ["center", textAlign]
  }, title), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "body-grey",
    fontSize: 1,
    letterSpacing: "0.5px",
    textAlign: "center",
    width: 1
  }, resultsCount + " results")), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flex: "1 0 25%",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    fontSize: 2,
    letterSpacing: "0.5px",
    mb: 0,
    onClick: cancelOnClick,
    version: "link"
  }, "Cancel"))));
};

MobileHeader.propTypes = propTypes;
MobileHeader.defaultProps = defaultProps;
MobileHeader.displayName = "Modules.MobileHeader";
var _default = MobileHeader;
exports["default"] = _default;